import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import { RootState } from "../stores/Store";
import { appVersion } from "../constants/gameDefaults"; // adjust the path as needed

function DebugFooter() {
  const lobby = useSelector(
    (state: RootState) => state.lobbyReducer.lobby,
    shallowEqual,
  );

  const responsivePlacement = isMobile ? "0px" : "10px";
  return (
    <div>
      <div
        style={{
          color: "white",
          position: "fixed",
          bottom: responsivePlacement,
          right: responsivePlacement,
          fontSize: "1rem",
        }}
      >
        version - {appVersion}
      </div>
      {lobby?.id && (
        <div
          style={{
            color: "white",
            position: "fixed",
            bottom: responsivePlacement,
            left: responsivePlacement,
            fontSize: "1rem",
          }}
        >
          {/* Game Id - {lobby.gameId}
          <br /> */}
          Lobby Id - {lobby.id}
        </div>
      )}
    </div>
  );
}

export default DebugFooter;
